/** копия метода ./declension.ts
 * Фабрика функций склонения существительных по числам.
 * @param singular именительный падеж ед.ч, например [1] центр
 * @param genitive родительный падеж ед.ч, например [2] центра
 * @param plural родительный падеж мн.ч, например [10] центров
 * @param fallback значение, используемое если передано не число, например руб. Если не передан, используется plural
 * @return {(val: number) => string} Функция, выводящая строку в нужном склонении для переданного числа.
 */

export function declensionFactory(singular: string, genitive: string, plural: string, fallback?: string) {
  return function (val: number): string {
    if (typeof val !== 'number') {
      console.error('Переданный аргумент для склонения не является числом, используется значение по умолчанию');
      return fallback ?? plural;
    }
    if (!Number.isSafeInteger(val)) {
      val = Math.floor(val);
    }

    val = Math.abs(val) % 100;
    if (val % 10 === 1 && val !== 11) {
      return singular;
    }
    if ([2, 3, 4].includes(val % 10) && (val > 20 || val < 10)) {
      return genitive;
    }
    if ([2, 3, 4].includes(val % 10) && val > 100) {
      return genitive;
    }
    return plural;
  };
}
